import React, { useEffect, useState } from "react";
import PublicLayout from "../components/PublicLayout";
import api from "../lib/api";
import { Camera, ShoppingBag, Check } from "lucide-react";
import { Badge } from "../components/ui/badge";

function ComingSoon({ label }) {
  return (
    <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center">
      <span className="rounded-full bg-gold px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-navy">Coming Soon</span>
      <p className="mt-4 text-slateBrand">{label} will be available here once H.E.A. publishes items.</p>
    </div>
  );
}

export default function MediaMerchandise() {
  const [media, setMedia] = useState([]);
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/media-days").then((r) => setMedia(r.data)).catch(() => {});
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  return (
    <PublicLayout>
      <section className="bg-navy topo-bg">
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
          <span className="eyebrow text-exploration">H.E.A. Media & H.E.A. Shop</span>
          <h1 className="mt-3 font-display text-4xl font-extrabold text-white lg:text-5xl">Media & Merchandise</h1>
          <p className="mt-4 max-w-xl text-white/70">H.E.A. photography, media packages, apparel and branded merchandise.</p>
        </div>
      </section>

      {/* MEDIA */}
      <section className="mx-auto max-w-6xl px-5 py-14 lg:px-8">
        <div className="flex items-center gap-2"><Camera className="h-5 w-5 text-brandblue" /><h2 className="font-display text-2xl font-bold text-navy">Media</h2></div>
        <div className="mt-6">
          {media.length === 0 ? <ComingSoon label="Media packages" /> : (
            <div className="space-y-8">
              {media.map((m) => (
                <div key={m.id} data-testid={`media-day-${m.id}`} className="rounded-2xl border border-slate-200 bg-white p-6">
                  <div className="font-display text-lg font-bold text-navy">{m.title}</div>
                  <div className="text-sm text-slateBrand">{m.date ? new Date(m.date).toLocaleDateString("en-US", { month: "long", day: "numeric" }) : ""} • {m.location}</div>
                  <div className="mt-5 grid gap-5 md:grid-cols-3">
                    {(m.packages || []).map((p) => (
                      <div key={p.name} className="rounded-xl border border-slate-200 p-5">
                        <div className="font-display font-bold text-navy">{p.name}</div>
                        <div className="mt-2 font-display text-2xl font-extrabold text-navy">${p.price}</div>
                        <ul className="mt-3 space-y-1">{(p.details || []).map((d) => <li key={d} className="flex items-start gap-2 text-sm text-slateBrand"><Check className="mt-0.5 h-4 w-4 shrink-0 text-successBrand" />{d}</li>)}</ul>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* MERCHANDISE */}
      <section className="mx-auto max-w-6xl px-5 pb-20 lg:px-8">
        <div className="flex items-center gap-2"><ShoppingBag className="h-5 w-5 text-brandblue" /><h2 className="font-display text-2xl font-bold text-navy">Merchandise</h2></div>
        <div className="mt-6">
          {products.length === 0 ? <ComingSoon label="Apparel and merchandise" /> : (
            <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
              {products.map((p) => (
                <div key={p.id} data-testid={`product-${p.id}`} className="overflow-hidden rounded-2xl border border-slate-200 bg-white card-lift">
                  <div className="flex h-48 items-center justify-center bg-cloud"><ShoppingBag className="h-16 w-16 text-navy/20" /></div>
                  <div className="p-6">
                    <div className="flex items-start justify-between">
                      <h3 className="font-display font-bold text-navy">{p.name}</h3>
                      {p.preorder && <Badge className="border-gold/40 bg-gold/15 text-[#8A5F00]">Preorder</Badge>}
                    </div>
                    <div className="mt-3 text-sm text-slateBrand">Member <span className="font-semibold text-navy">${p.member_price}</span> · <span className="font-semibold text-navy">${p.price}</span></div>
                    <div className="mt-2 text-xs text-slateBrand">{(p.variants || []).join(" · ")}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </PublicLayout>
  );
}
